
import { images } from ".";

const preventions = [
    {
        id: 1,
        image: images.prevention1,
        title: "Install Fire Alarms",
        overviews: [
            "Trust us with your fire safety matters. Our fire safety service provides expert advice and guidance to enhance community safety and prevent fire incidents with confidence.",
            "Whether you need assistance with installing fire alarms, fire safety education, or emergency preparedness, our team ensures comprehensive handling of your fire safety matters."
        ],
        gallery: [
            images.prevention1Gallery1,
            images.prevention1Gallery2
        ],
        installations: [
            "Professional Installation Services",
            "Location Assessment for Optimal Coverage",
            "Testing and Maintenance Guidance",
            "Integration with Emergency Systems",
            "Community Outreach and Training"
        ],
        considerations: [
            "Fire Hazard Identification",
            "Development of Fire Safety Protocols",
            "Regular Fire Drills and Exercises",
            "Inspection of Fire Safety Equipment",
            "Collaboration with Emergency Services"
        ],
        impacts: [
            "Increased Community Awareness",
            "Reduced Fire Incidents",
            "Enhanced Emergency Response",
            "Improved Fire Safety Culture",
            "Stronger Community Resilience"
        ]
    },
    {
        id: 2,
        image: images.prevention2,
        title: "Create Escape Plan",
        overviews: [
            "Rely on our expertise to help your household or organization develop a safe and effective escape strategy in the event of a fire. We guide you through every step to ensure you're ready when it matters most.",
            "From creating custom fire escape routes to conducting safety drills, our fire safety professionals make sure everyone knows what to do and where to go during an emergency."
        ],
        gallery: [
            images.prevention2Gallery1,
            images.prevention2Gallery2
        ],
        installations: [
            "Customized Escape Route Planning",
            "Clear Marking of Exit Paths",
            "Installation of Exit Signs & Emergency Lights",
            "Fire Exit Accessibility Improvements",
            "Escape Plan Display Setup"
        ],
        considerations: [
            "Household or Building Layout Analysis",
            "Consideration of Occupant Mobility",
            "Assignment of Escape Responsibilities",
            "Regular Escape Plan Reviews",
            "Safe Meeting Point Designation"
        ],
        impacts: [
            "Faster and Safer Evacuations",
            "Minimized Panic During Emergencies",
            "Improved Family or Staff Preparedness",
            "Strengthened Emergency Communication",
            "Saved Lives Through Proactive Planning"
        ]
    },
    {
        id: 3,
        image: images.prevention3,
        title: "Fire Extinguisher Training",
        overviews: [
            "Be prepared to act swiftly in the face of fire. Our fire extinguisher training empowers individuals with the knowledge and confidence to respond effectively during fire emergencies.",
            "Whether at home, work, or in public spaces, learning how to use a fire extinguisher properly can be the difference between minor damage and major disaster. Our sessions cover hands-on practice, safety tips, and fire classification."
        ],
        gallery: [
            images.prevention3Gallery1,
            images.prevention3Gallery2
        ],
        installations: [
            "Hands-On Extinguisher Demonstrations",
            "Training on Different Extinguisher Types",
            "Correct Usage Techniques (P.A.S.S.)",
            "Identification of Fire Classes",
            "On-Site Safety Sessions"
        ],
        considerations: [
            "Assessment of Training Needs",
            "Accessibility to Extinguishers",
            "Routine Refresher Training",
            "Incorporation into Workplace Safety Programs",
            "Clear Labeling of Equipment"
        ],
        impacts: [
            "Quick and Informed Responses",
            "Minimized Property Damage",
            "Boosted Confidence During Fire Events",
            "Enhanced Workplace Safety Compliance",
            "Reduced Fire Spread Risks"
        ]
    },
    {
        id: 4,
        image: images.prevention4,
        title: "Check Electrical Wiring",
        overviews: [
            "Prevent electrical fires before they start. Regular inspection of wiring systems ensures your property stays safe and up to code. Faulty or aging electrical components can pose serious fire risks.",
            "Our fire safety service provides thorough electrical assessments, helping you identify hazards and implement proper safety measures to avoid unexpected electrical incidents."
        ],
        gallery: [
            images.prevention4Gallery1,
            images.prevention4Gallery2
        ],
        installations: [
            "Complete Electrical System Inspections",
            "Identification of Frayed or Exposed Wires",
            "Replacement of Faulty Components",
            "Load and Circuit Testing",
            "Installation of Surge Protectors and Breakers"
        ],
        considerations: [
            "Age of Wiring Systems",
            "Use of Certified Electricians",
            "Compliance with Safety Standards",
            "Regular Maintenance Scheduling",
            "Awareness of Warning Signs (flickering lights, overheating, etc.)"
        ],
        impacts: [
            "Reduced Risk of Electrical Fires",
            "Extended Life of Electrical Equipment",
            "Enhanced Home and Workplace Safety",
            "Lower Repair and Insurance Costs",
            "Peace of Mind for Property Owners"
        ]
    },
    {
        id: 5,
        image: images.prevention5,
        title: "Maintain Fire Exits",
        overviews: [
            "Safe evacuation starts with accessible fire exits. Regular maintenance ensures all exit routes remain clear, visible, and functional during emergencies.",
            "Our fire safety service helps buildings stay compliant by inspecting, maintaining, and clearly marking all fire exits to ensure everyone can escape quickly and safely when it matters most."
        ],
        gallery: [
            images.prevention5Gallery1,
            images.prevention5Gallery2
        ],
        installations: [
            "Inspection of All Exit Doors and Pathways",
            "Installation of Illuminated Exit Signs",
            "Ensuring Obstruction-Free Routes",
            "Exit Door Functionality Testing",
            "Emergency Lighting Setup"
        ],
        considerations: [
            "Building Occupancy and Layout",
            "Regular Blockage and Obstruction Checks",
            "Compliance with Fire Safety Codes",
            "Exit Route Mapping and Signage",
            "Clear Access for Individuals with Disabilities"
        ],
        impacts: [
            "Faster and Safer Evacuations",
            "Increased Compliance with Safety Regulations",
            "Improved Emergency Preparedness",
            "Reduced Risk of Injuries During Escape",
            "Boosted Confidence in Safety Measures"
        ]
    },
    {
        id: 6,
        image: images.prevention6,
        title: "Educate Residents",
        overviews: [
            "Knowledge saves lives. Educating residents about fire safety practices builds a more alert and prepared community. Awareness is the first step toward prevention.",
            "Our fire safety education programs are tailored for all age groups, covering essential topics like fire prevention, emergency response, and the proper use of safety equipment."
        ],
        gallery: [
            images.prevention6Gallery1,
            images.prevention6Gallery2
        ],
        installations: [
            "Community Fire Safety Workshops",
            "Distribution of Educational Materials",
            "Interactive Safety Demonstrations",
            "School and Youth Awareness Programs",
            "Emergency Contact and Response Guidelines"
        ],
        considerations: [
            "Demographics and Language Needs",
            "Accessible Learning Formats",
            "Engagement Through Visual Aids",
            "Follow-Up Assessments and Quizzes",
            "Partnerships with Local Organizations"
        ],
        impacts: [
            "Stronger Community Preparedness",
            "Lower Fire-Related Injuries and Fatalities",
            "Wider Reach of Fire Safety Knowledge",
            "More Proactive Safety Behavior",
            "Long-Term Cultural Shift Toward Prevention"
        ]
    }
];

export default preventions;